module.exports = __webpack_public_path__ + "img/aboutUs5_en.9e1ecb0.png";